module.exports = __webpack_public_path__ + "assets/img/banner.79d08d0d.png";